import { render, staticRenderFns } from "./DialogGroup.vue?vue&type=template&id=4dd4fb72&scoped=true&"
import script from "./DialogGroup.vue?vue&type=script&lang=js&"
export * from "./DialogGroup.vue?vue&type=script&lang=js&"
import style0 from "./DialogGroup.vue?vue&type=style&index=0&lang=postcss&"
import style1 from "./DialogGroup.vue?vue&type=style&index=1&id=4dd4fb72&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd4fb72",
  null
  
)

export default component.exports